import React, { Fragment, useEffect, useState } from 'react';
import { PageBody } from '../../components/SiteWrapper';
import { Card, Col, Row } from 'react-bootstrap';
import { FormFieldSelect } from '../../components/Form/FormField';
import { getAll } from '../../api/MinistryExams';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import useIsMobile from '../../hooks/useIsMobile';
import NoDataFound from '../../components/General/NoDataFound';
import { getExamStatusPerfoma } from '../../api/ExamsAPI';
import AnimatedComponent from '../../components/Animation/AnimatedComponent';
import StatusCapsual from '../../components/DataTable/StatusCapsule';
import { Link } from 'react-router-dom';
import DateCard from '../ExamReport/DateCard';
import DateCardPerfoma from '../ExamReport/DateCardPerfoma';

const PerfomaSubmission = () => {
  const isMobile = useIsMobile();
  const [exams, setExams] = useState([]);
  const [examDays, setExamDays] = useState([]);
  const [selectedExams, setSelectedExams] = useState([]);

  const defaultFilterValue = {
    exam: '',
  };
  const [isLoading, setIsLoading] = useState(false);
  const {
    control,
    formState: { errors: dashboardFilterError },
    watch,
    setValue,
    getValues,
  } = useForm({
    mode: 'onChange',
    defaultValues: defaultFilterValue,
  });
  const [filter, setFilter] = useState({
    _page: 1,
    _limit: 1000,
    q: '',
    _sort: 'id',
    _order: 'desc',
    // status:"1"
  });
  const fetchAllMinistryExams = async () => {
    let exams = await getAll(filter);

    const today = new Date();
    const todayStart = new Date(today.setHours(0, 0, 0, 0)); // Start of today

    exams.data.records = exams.data.records.filter(
      (record) => new Date(record.shift_1_start_time) < todayStart
    );

    setExams(exams.data.records);
  };
  const getExamDaysWithMaxDays = (data) => {
    let maxDaysExam = null;
    let maxDaysCount = 0;

    if (data) {
      data.Exams.forEach((exam) => {
        const examDaysCount = exam.examDays.length;

        if (examDaysCount > maxDaysCount) {
          maxDaysCount = examDaysCount;
          maxDaysExam = exam;
        }
      });
      if (maxDaysExam && maxDaysExam.examDays) {
        // Sort examDays by date in ascending order
        maxDaysExam.examDays.sort(
          (a, b) => new Date(a.date) - new Date(b.date)
        );
      }

      return maxDaysExam ? maxDaysExam?.examDays : [];
    }
  };
  useEffect(() => {
    fetchAllMinistryExams();
  }, []);
  const fetchExams = async (selectedExam, selectedExamDay) => {
    const examData = await getExamStatusPerfoma({
      selectedExam: selectedExam,
      selectedExamDay: selectedExamDay,
    });
    setSelectedExams(examData?.data?.exam);
  };

  const selectedExam = watch('exam');
  const selectedExamDay = watch('examDay');
  useEffect(() => {
    setValue('examDay', []);
    if (selectedExam) {
      const examDays = getExamDaysWithMaxDays(
        exams.find((exam) => exam.id === selectedExam.value)
      );
      setExamDays(examDays);
      //   fetchDashboardData(selectedExam.value);
    }
  }, [selectedExam]);
  useEffect(() => {
    if (selectedExamDay) {
      fetchExams(selectedExam.value, selectedExamDay.value);
    }
  }, [selectedExamDay]);
  return (
    <PageBody>
      <Row className='d-flex align-items-center mb-2'>
        <Col md='8'>
          <h2 className='page-title'>Perfoma Submission</h2>
        </Col>
        <Col md='2'>
          <FormFieldSelect
            name='exam'
            control={control}
            options={exams.map((exam) => ({
              label: exam.exam_name,
              value: exam.id,
            }))}
            error={dashboardFilterError?.role}
            size='12'
            placeholder='Select Exam'
          />
        </Col>
        <Col md='2'>
          <FormFieldSelect
            name='examDay'
            control={control}
            options={[
              { label: 'All Exam Days', value: null },
              ...examDays.map((day) => ({
                label: moment(day.date).format('DD/MM'),
                value: day.date,
              })),
            ]}
            error={dashboardFilterError?.role}
            size='12'
            placeholder='All Exam Days'
            disabled={!getValues('exam')}
          />
        </Col>
      </Row>
      <Row>
        {selectedExam && selectedExamDay ? (
          <AnimatedComponent
            as={Card}
            key={selectedExam.value}
            className='mt-3'
          >
            <Card.Body className='p-3'>
              <div className=' d-flex justify-content-between'>
                {console.log('selectedExams', selectedExams)}
                <div>
                  <h3 className='mb-1 fs-18 fw-medium'>
                    {selectedExams?.exam_name}
                  </h3>
                  <Card.Text className='text-secondary mb-2'>
                    {selectedExams?.Post?.description} (
                    {selectedExams?.Post?.name})
                  </Card.Text>
                  <StatusCapsual status={selectedExams?.status} />
                </div>
              </div>
            </Card.Body>
            <Card.Body className='p-3'>
              <Row className='g-3'>
                {selectedExams?.examDays?.length > 0 &&
                  selectedExams.examDays[0]?.examCenters?.length > 0 &&
                  selectedExams.examDays[0].examCenters.map(
                    (exmDay, dayInd) => (
                      <DateCardPerfoma
                        centers={exmDay}
                        key={dayInd}
                        examDats={selectedExams.examDays[0]}
                        examData={selectedExams}
                      />
                    )
                  )}
              </Row>
            </Card.Body>
          </AnimatedComponent>
        ) : (
          <NoDataFound
            message='No active exams currently. Please select exam/exam day filters to see past exam data.'
            minHeight={isMobile ? '80vh' : '50vh'}
          />
        )}
      </Row>
    </PageBody>
  );
};

export default PerfomaSubmission;
